/* Chapter 22 theme — mobile menu + brand motion (reduced-motion aware). */
(function () {
  'use strict';
  var root = document.documentElement;

  var lastFocused = null;

  function menuPanel() { return document.querySelector('.mobile-menu__panel'); }

  function focusables(el) {
    if (!el) return [];
    return [].slice.call(el.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (n) { return n.offsetParent !== null; });
  }

  function closeMenu() {
    if (!root.hasAttribute('data-menu-open')) return;
    root.removeAttribute('data-menu-open');
    document.body.style.overflow = '';
    var t = document.querySelector('[data-menu-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
    /* Hand focus back where it came from, not to the top of the document. */
    if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
    lastFocused = null;
  }

  function openMenu(toggle) {
    lastFocused = toggle || document.activeElement;
    root.setAttribute('data-menu-open', '');
    document.body.style.overflow = 'hidden';
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    var close = document.querySelector('.mobile-menu__close');
    if (close) close.focus();
  }

  /* Keep Tab inside the panel while it is open. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !root.hasAttribute('data-menu-open')) return;
    var items = focusables(menuPanel());
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      e.preventDefault();
      if (root.hasAttribute('data-menu-open')) closeMenu();
      else openMenu(toggle);
      return;
    }
    if (e.target.closest('[data-menu-close]')) closeMenu();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (closeNavGroups(true)) return;   // a dropdown was open: that goes first
    closeMenu();
  });

  /* Motion: rise & fade + Heat-Index ignite on scroll. Progressive enhancement. */
  function initMotion() {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      var sel = 'main .section-head, main .hero__inner, main .genre-tile, main .damage-report, main .club__inner, main figure, main .product-grid, main [class*="grid--products"]';
      var els = [].slice.call(document.querySelectorAll(sel));
      var ro = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); ro.unobserve(x.target); } });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
      els.forEach(function (el) { el.classList.add('js-reveal'); ro.observe(el); });
      setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);

      var hs = [].slice.call(document.querySelectorAll('.heat'));
      var ho = new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('heat--ignite'); ho.unobserve(x.target); } });
      }, { threshold: 0.6 });
      hs.forEach(function (el) { ho.observe(el); });
    } catch (err) { /* motion is a nicety */ }
  }
  /* ------------------------------------------------------------------
     Quantity stepper. The markup shipped with data-qty-inc/dec buttons
     but nothing bound to them, so they were inert.
     ------------------------------------------------------------------ */
  function stepQty(input, delta) {
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;
    var next = Math.max(min, current + delta);
    if (next === current) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.addEventListener('click', function (e) {
    var dec = e.target.closest('[data-qty-dec]');
    var inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;
    var group = (dec || inc).closest('.qty');
    var input = group && group.querySelector('[data-qty]');
    if (!input) return;
    e.preventDefault();
    stepQty(input, dec ? -1 : 1);
  });

  /* ------------------------------------------------------------------
     Shelf dropdowns. The chevron is the control; on a desktop pointer the
     panel also opens on hover. aria-expanded is set from the same code path
     in both cases, so what a screen reader is told is never a guess.
     ------------------------------------------------------------------ */
  var finePointer = window.matchMedia
    ? window.matchMedia('(hover: hover) and (pointer: fine)')
    : { matches: false };

  function setGroup(group, open) {
    if (!group) return;
    var trigger = group.querySelector('[data-nav-trigger]');
    if (open) group.setAttribute('data-open', '');
    else group.removeAttribute('data-open');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeNavGroups(refocus, except) {
    var open = document.querySelectorAll('[data-nav-group][data-open]');
    if (!open.length) return false;
    var closedAny = false;
    for (var i = 0; i < open.length; i++) {
      if (except && open[i] === except) continue;
      if (refocus) {
        var t = open[i].querySelector('[data-nav-trigger]');
        if (t && open[i].contains(document.activeElement)) t.focus();
      }
      setGroup(open[i], false);
      closedAny = true;
    }
    return closedAny;
  }

  function initNavGroups() {
    var groups = document.querySelectorAll('[data-nav-group]');
    for (var i = 0; i < groups.length; i++) {
      (function (group) {
        var trigger = group.querySelector('[data-nav-trigger]');
        if (!trigger) return;
        var inDrawer = !!group.closest('.mobile-menu');

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var willOpen = !group.hasAttribute('data-open');
          closeNavGroups(false, group);
          setGroup(group, willOpen);
        });

        if (!inDrawer) {
          group.addEventListener('mouseenter', function () {
            if (!finePointer.matches) return;
            closeNavGroups(false, group);
            setGroup(group, true);
          });
          group.addEventListener('mouseleave', function () {
            if (!finePointer.matches) return;
            setGroup(group, false);
          });
          group.addEventListener('focusout', function (e) {
            if (!group.contains(e.relatedTarget)) setGroup(group, false);
          });
        }
      })(groups[i]);
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-group]')) closeNavGroups(false);
    });
  }

  /* ------------------------------------------------------------------
     Variant switching: price, stock line and button state follow the
     selected variant, and the URL keeps ?variant= so links are shareable.
     ------------------------------------------------------------------ */
  function initVariants() {
    var select = document.querySelector('[data-variant-select]');
    if (!select) return;
    var priceEl = document.querySelector('[data-product-price]');
    var stockEl = document.querySelector('[data-product-stock]');
    var addBtn = document.querySelector('[data-add-button]');
    var soldOutLine = stockEl ? (stockEl.getAttribute('data-soldout') || 'Currently off the shelf') : '';
    var inStockLine = stockEl ? (stockEl.getAttribute('data-instock') || stockEl.textContent.trim()) : '';

    select.addEventListener('change', function () {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var available = opt.getAttribute('data-available') === 'true';
      var price = opt.getAttribute('data-price') || '';
      var compare = opt.getAttribute('data-compare') || '';

      if (priceEl && price) {
        priceEl.innerHTML = compare
          ? '<s>' + compare + '</s> ' + price
          : price;
      }
      if (stockEl) stockEl.textContent = available ? inStockLine : soldOutLine;

      // A variant with no image of its own must fall back to the product's
      // default photo. Leaving the previous variant's picture up is worse than
      // showing a generic one — it tells the shopper they are buying red when
      // the form says blue.
      var img = document.querySelector('[data-product-image]');
      if (img) {
        var src = opt.getAttribute('data-image') || img.getAttribute('data-default-src');
        var ss = opt.getAttribute('data-srcset') || img.getAttribute('data-default-srcset');
        var alt = opt.getAttribute('data-alt') || img.getAttribute('data-default-alt');
        if (src) img.src = src;
        img.srcset = ss || '';
        if (alt) img.alt = alt;
      }

      var skuEl = document.querySelector('[data-product-sku]');
      if (skuEl) {
        var sku = opt.getAttribute('data-sku') || '';
        skuEl.textContent = sku;
        var row = skuEl.closest('.product__spec-row');
        if (row) row.hidden = !sku;   // the row is always in the DOM now
      }
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to cart' : 'Sold out';
      }

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', opt.value);
        window.history.replaceState({}, '', url.toString());
      } catch (err) { /* URL rewriting is a nicety */ }
    });
  }

  /* Guard against a double-tap adding the same line twice. */
  function initFormGuard() {
    var form = document.getElementById('product-form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var btn = form.querySelector('[data-add-button]');
      if (!btn || btn.disabled) return;
      btn.setAttribute('aria-busy', 'true');
      setTimeout(function () { btn.disabled = true; }, 0);
      /* Re-enable if the browser restores the page from bfcache. */
      window.addEventListener('pageshow', function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }, { once: true });
    });
  }

  /* Collection filters submit on change; the form works without JS too. */
  function initFilters() {
    var form = document.getElementById('c22-filters');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-auto-submit]')) form.submit();
    });
  }

  /* Cart quantity changes post straight away; the Update button remains
     the no-JS path and is hidden once we can submit on change. */
  function initCart() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;
    var updateBtn = form.querySelector('[data-cart-update]');
    if (updateBtn) updateBtn.hidden = true;
    var pending;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty]')) return;
      clearTimeout(pending);
      pending = setTimeout(function () { form.submit(); }, 250);
    });
  }

  function initShop() { initNavGroups(); initVariants(); initFormGuard(); initFilters(); initCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShop);
  else initShop();

  if (document.readyState === 'complete') initMotion();
  else window.addEventListener('load', initMotion);
})();
